const PhotoListForm = ({
photos = [],
loading = false,
error = null,
onDelete,
title = "Photo List",
gridClassName = "grid grid-cols-1 md:grid-cols-3 gap-4",
thumbnailHeightClassName = "h-48",
showDelete = true,
}) => {
return (
<div className="bg-white rounded-lg shadow">
    <div className="p-4 border-b text-sm font-medium text-gray-800">{title}</div>

    {loading && <div className="p-4 text-sm text-gray-500">Loading...</div>}
    {error && <div className="p-4 text-sm text-red-600">Failed to load photos.</div>}
    {!loading && !error && photos.length === 0 && (
    <div className="p-4 text-sm text-gray-500">No photos yet.</div>
    )}

    {!loading && !error && photos.length > 0 && (
    <div className={`${gridClassName} p-4`}>
        {photos.map((p) => (
        <div key={p.id} className="border rounded-lg overflow-hidden">
            {p.file_url ? (
            <img
                src={p.file_url}
                alt={p.caption || p.file_name}
                className={`w-full ${thumbnailHeightClassName} object-cover`}
            />
            ) : (
            <div className={`w-full ${thumbnailHeightClassName} bg-gray-100`} />
            )}

            <div className="p-3 text-sm">
            <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                <div className="font-medium truncate">{p.caption || p.file_name}</div>
                <div className="text-gray-600 line-clamp-2">{p.description || "-"}</div>
                </div>

                {showDelete && typeof onDelete === "function" ? (
                <button
                    type="button"
                    onClick={() => onDelete(p.id)}
                    className="text-red-600 underline text-sm whitespace-nowrap"
                >
                    Delete
                </button>
                ) : null}
            </div>

            {Array.isArray(p.tags) && p.tags.length ? (
                <div className="mt-2 flex flex-wrap gap-2">
                {p.tags.map((t) => (
                    <span key={t} className="text-xs bg-gray-100 px-2 py-1 rounded-full">
                    {t}
                    </span>
                ))}
                </div>
            ) : null}
            </div>
        </div>
        ))}
    </div>
    )}
</div>
);
};

export default PhotoListForm;